import React, { useState, useEffect } from "react";
import { Typography, Button, Pagination, App, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@/store/hooks";
import { useTranslation } from "react-i18next";
import { getCarpoolList, getCarpoolMemberPurchaseHistory } from "@/api/car";
import { getProductCategoryAllList, deleteHistoryRecord } from "@/api/products";
import styles from "./index.module.scss";
import icon1 from "@/assets/images/组 3047@2x.png";
import icon2 from "@/assets/images/组 3172@2x.png";
import icon3 from "@/assets/images/路径 2061@2x.png";
import icon4 from "@/assets/images/路径 2253@2x.png";
import orderNoneIcon1 from "@/assets/images/order-none1.png";
import orderNoneIcon2 from "@/assets/images/order-none2.png";
import carIcon2 from "@/assets/images/路径 2012@2x.png";
import NearbyOrders from "@/pages/EmergencyService/components/NearbyOrders/NearbyOrders";
import { useAppDispatch } from "@/store/hooks";
import { setUserInfo } from "@/store/slices/userSlice";
import { CheckOutlined } from "@ant-design/icons";

import Membership from "@/components/Membership";
import OrderEmpty from "@/components/OrderEmpty/orderEmpty";

const { Title } = Typography;

//级联选择器选项类型
interface CascaderOption {
  value: number;
  label: string;
  children?: CascaderOption[];
  isLeaf?: boolean;
}

//级联选择器选项类型
interface IClassification {
  is_active: boolean;
  is_delete: boolean;
  order: any;
  parent_id: number;
  product_category_id: number;
  product_category_name: string;
  child?: IClassification[];
}

interface MembershipBenefit {
  title: string;
  description: string;
}

interface MembershipCard {
  title: string;
  description: string;
  isActive: boolean;
  expirationDate?: string;
  actionText: string;
  benefits: MembershipBenefit[];
}

interface OrderItem {
  carpool_order_id?: string;
  departure_date: string;
  acceptable_advance_delay: string;
  stopovers: string;
  starting_point_state: string;
  starting_point_city: string;
  starting_point_address: string;
  destination_point_state: string;
  destination_point_city: string;
  destination_point_address: string;
  seats_needed: string;
  has_luggage: boolean;
  final_price: string;
  budget_price: string;
  service_requirements: string;
  notes: string;
  distance: string;
}

const MembershipService: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"ride" | "emergency">("ride");
  //国际化
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { message } = App.useApp();
  // 是否是会员
  const [isMember, setIsMember] = useState(false);
  // 拼车相关状态
  const [carList, setCarList] = useState<OrderItem[]>([]);
  const [params, setParams] = useState<any>({
    page_num: 1,
    page_size: 20,
    total: 0,
    totalPages: 0,
    keyword: "",
    user_latitude: 0,
    user_longitude: 0,
  });
  const [historyParams, setHistoryParams] = useState<any>({
    page_num: 1,
    page_size: 4,
    total: 0,
    totalPages: 0,
  });
  const [goToPage, setGoToPage] = useState<string>("");
  const [goToHistoryPage, setGoToHistoryPage] = useState<string>("");
  const userInfo = useAppSelector((state) => state.user.userInfo);
  // 获取经纬度
  const latitude = useAppSelector((state) => state.user.latitude);
  const longitude = useAppSelector((state) => state.user.longitude);

  // NearbyOrders相关状态
  const [cascaderOptions, setCascaderOptions] = useState<CascaderOption[]>([]);
  const [refreshNearbyOrders, setRefreshNearbyOrders] = useState<number>(0);

  // 将原始分类数据转换为Cascader需要的格式
  const transformToCascaderOptions = (
    data: IClassification[] = []
  ): CascaderOption[] => {
    return data.map((item) => {
      const hasChildren = item.child && item.child.length > 0;
      return {
        value: item.product_category_id,
        label: item.product_category_name,
        children: hasChildren
          ? transformToChildrenOptions(item.child)
          : undefined,
        isLeaf: !hasChildren, // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 转换子分类数据
  const transformToChildrenOptions = (
    children: IClassification[] = []
  ): CascaderOption[] => {
    return children.map((child) => {
      const hasChildren = child.child && child.child.length > 0;
      return {
        value: child.product_category_id,
        label: child.product_category_name,
        children: hasChildren
          ? transformToChildrenOptions(child.child)
          : undefined,
        isLeaf: !hasChildren, // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 获取拼车列表方法
  const getProductListFn = (params: any) => {
    getCarpoolList(params).then((res) => {
      if (res.code == 200) {
        setCarList(res.data);
        setParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage("");
      }
    });
  };

  // 处理页码输入框回车事件
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleGoToPage();
    }
  };
  // 处理页码输入框回车事件
  const handleHistoryPageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleHistoryGoToPage();
    }
  };
  // 分页变化
  const paginationChange = (page: number, pageSize: number) => {
    console.log("page", page, pageSize);

    const myParams = {
      ...params,
      page_num: page,
      page_size: pageSize,
    };
    setParams(myParams);
    getProductListFn(myParams);
  };
  // 分页变化
  const historyPaginationChange = (page: number, pageSize: number) => {
    console.log("page", page, pageSize);

    const myParams = {
      ...historyParams,
      page_num: page,
      page_size: pageSize,
    };
    setHistoryParams(myParams);
    // getProductListFn(myParams);
  };

  // 跳转到指定页
  const handleGoToPage = () => {
    const page = parseInt(goToPage);

    if (isNaN(page) || page < 1) {
      return;
    }

    if (page > params.totalPages) {
      return;
    }

    const myParams = {
      ...params,
      page_num: page,
    };

    setParams(myParams);
    getProductListFn(myParams);
  };
  // 跳转到指定页
  const handleHistoryGoToPage = () => {
    const page = parseInt(goToHistoryPage);

    if (isNaN(page) || page < 1) {
      return;
    }

    if (page > historyParams.totalPages) {
      return;
    }

    const myParams = {
      ...historyParams,
      page_num: page,
    };

    setHistoryParams(myParams);
    // getProductListFn(myParams);
  };

  // 购买历史数据
  const [purchaseHistoryData, setPurchaseHistoryData] = useState<any>({
    ride: [
      //   {
      //     "type": "vip_purchase",
      //     "record_id": "VIP-mzqew1759139999368",
      //     "title": "\u62fc\u8f66\u4f1a\u5458\u8d2d\u4e70",
      //     "amount": 50.0,
      //     "purchase_time": "2025-09-29 09:59:59",
      //     "expire_time": "2026-09-29 09:59:59",
      //     "status": "active",
      //     "duration_days": 364,
      //     "description": "\u62fc\u8f66\u4f1a\u5458 - \u62fc\u8f66\u4f1a\u5458",
      //     "extension": {}
      // card_type:"yearly",
      // },
    ],
    emergency: [
      {
        id: 1,
        date: "2025/08/16",
        orderNumber: "14785236987463157245",
        membershipType: "Emergency Service Member",
        expirationDate: "08/16/2026 11:15",
        distance: "10 Miles",
        purchaseDuration: "1 Year",
        goodsAmount: "$50",
        status: "Active",
      },
      {
        id: 2,
        date: "2024/08/16",
        orderNumber: "14785236987463157247",
        membershipType: "Emergency Service Member",
        expirationDate: "08/16/2025 11:15",
        distance: "15 Miles",
        purchaseDuration: "1 Year",
        goodsAmount: "$50",
        status: "Expired",
      },
    ],
  });
  //console.log("t ===== ",t('membership.MembershipServices'))
  const membershipData: Record<string, MembershipCard> = {
    ride: {
      title: t('membership.MembershipServices'),
      description: t('membership.AccessAnywhere'),
      isActive: true,
      expirationDate: "08/16/2026 11:15",
      actionText: t('membership.Renew'),
      benefits: [
        {
          title: t('membership.RideBoard'),
          description: t('membership.RideDeliveryService'),
        },
        {
          title: t('membership.StoreAccess'),
          description: t('membership.OpenYourOwnShop'),
        },
        {
          title: t('membership.EmergencyServiceAccess'),
          description: t('membership.QuickHelpWhenItMatters'),
        },
      ],
    },
    emergency: {
      title: "Emergency Service Member",
      description: "Helping You Solve Everyday Service Needs",
      isActive: false,
      actionText: "Join Membership",
      benefits: [
        {
          title: "Post & Claim Orders",
          description: "Publish tasks or grab available ones",
        },
        {
          title: "Priority Nearby Orders",
          description: "Get recommended local orders first",
        },
        {
          title: "Early Reservations",
          description: "Book ahead before others",
        },
      ],
    },
  };

  const currentMembership = membershipData[activeTab];
  // 添加会员弹窗状态控制
  const [membershipModalOpen, setMembershipModalOpen] =
    useState<boolean>(false);

  // 支付成功弹窗
  const [showPaySuccess, setShowPaySuccess] = useState(false);
  const closePaySuccess = () => setShowPaySuccess(false);

  // 处理会员购买弹窗的回调函数
  const handleMembershipCancel = () => {
    setMembershipModalOpen(false);
  };

  //支付会员确认
  const handleMembershipConfirm = (values: any) => {
    console.log("Membership purchase confirmed:", values);

    // 检查是否是支付成功
    if (values.paymentSuccess) {
      message.success(
        "Membership purchased successfully! You can now submit emergency service requests."
      );
      setMembershipModalOpen(false);
      // setIsMember(true);
      setShowPaySuccess(true);

      // // 支付成功后，更新 localStorage 中的 userinfo
      const userInfoStr = localStorage.getItem("userInfo");
      let userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
      //把购买的会员标识手动处理
      userInfo.carpool_service_member = true;

      dispatch(setUserInfo(userInfo));
      getPurchaseHistory(historyParams);
    } else {
      setMembershipModalOpen(false);
      // // 如果没有支付成功信息，按原来的逻辑处理
    }
  };

  // 拼车会员续期
  const handleRenew = () => {
    //如果乘客还没有注册会员
    setMembershipModalOpen(true);
  };

  // 获取拼车会员购买历史
  const getPurchaseHistory = (params: any) => {
    getCarpoolMemberPurchaseHistory(params).then((res) => {
      console.log(res, "getCarpoolMemberPurchaseHistory");
      if (res.code === 200) {
        const data = {
          ...purchaseHistoryData,
          ride: res?.data?.records || [],
        };

        setPurchaseHistoryData(data);
        setHistoryParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: res.data.pagination.total || 0,
          totalPages: res.data.pagination.totalPages || 1,
        }));
        setGoToHistoryPage("");
      }
    });
  };
  // 检查会员状态
  useEffect(() => {
    // 判断是否是会员
    if (!!userInfo?.carpool_service_member) {
      setIsMember(true);
    }
  }, [userInfo]);
  // 初始化获取分类数据
  useEffect(() => {
    // 获取商品分类列表
    // product_category_type_id 1商品 2服务商品
    getProductCategoryAllList(2)
      .then((res) => {
        console.log(res, "getProductCategoryAllList");
        if (res.code === 200) {
          const data = res.data || [];
          //格式化分类数据
          const options = transformToCascaderOptions(data);
          setCascaderOptions(options);
        }
      })
      .catch((error) => {
        console.error("获取服务分类失败:", error);
      });

    // 获取拼车会员购买历史
    getPurchaseHistory(historyParams);

    // 获取拼车列表
    if (latitude && longitude) {
      const myParams = {
        ...params,
        user_latitude: latitude, // 41.71882
        user_longitude: longitude, // -72.99009
      };
      setParams(myParams);
      // 获取拼车列表
      getProductListFn(myParams);
    }
  }, []);

  return (
    <div className={styles["membership-container"]}>
      <div className={styles["header-section"]}>
        <Title level={1} className={styles["main-title"]}>
          {t("membership.MembershipServices")}
        </Title>
        <div className={styles["subtitle-section"]}>
          <Title level={3} className={styles["subtitle"]}>
            {t("membership.YourMembership")}
          </Title>
          <span className={styles["subtitle-description"]}>
            ({t("membership.AccessAnywhere")})
          </span>
        </div>
      </div>
      <div className={styles["cards-container"]}>
        <div
          className={`${styles["membership-card"]} ${
            activeTab === "ride" ? styles["active"] : styles["inactive"]
          }`}
          onClick={() => setActiveTab("ride")}
        >
          <div className={styles["card-header"]}>
            <div className={styles["header-left"]}>
              <img
                src={activeTab === "ride" ? icon1 : icon2}
                alt="Ride Board Member Icon"
                className={styles["card-icon"]}
              />
              <div className={styles["header-info"]}>
                <h3 className={styles["card-title"]}>
                  {membershipData.ride.title}
                </h3>
                <p className={styles["card-description"]}>
                  {membershipData.ride.description}
                </p>
                <p className={styles["card-description"]}>
                  {t("membership.ExpirationDate")}:{" "}
                  {membershipData.ride.expirationDate}
                </p>
              </div>
            </div>
            <span
              className={styles["action-link"]}
              onClick={() => handleRenew()}
            >
              {isMember ? t("membership.Renew") : t("membership.Open")}
            </span>
          </div>
          <div className={styles["divider"]}></div>

          <div className={styles["benefits-section"]}>
            {membershipData.ride.benefits.map((benefit, index) => (
              <div key={index} className={styles["benefit-item"]}>
                <img
                  src={activeTab === "ride" ? icon3 : icon4}
                  alt="Benefit Icon"
                  className={styles["benefit-icon"]}
                />
                <div className={styles["benefit-content"]}>
                  <h4 className={styles["benefit-title"]}>
                    {benefit.title}&nbsp;-&nbsp;
                  </h4>
                  <p className={styles["benefit-description"]}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className={`${styles["membership-card"]} ${
            activeTab === "emergency" ? styles["active"] : styles["inactive"]
          }`}
          onClick={() => setActiveTab("emergency")}
          style={{ visibility: "hidden" }}
        >
          <div className={styles["card-header"]}>
            <div className={styles["header-left"]}>
              <img
                src={activeTab === "emergency" ? icon1 : icon2}
                alt="Emergency Service Member Icon"
                className={styles["card-icon"]}
              />
              <div className={styles["header-info"]}>
                <h3 className={styles["card-title"]}>
                  {membershipData.emergency.title}
                </h3>
                <p className={styles["card-description"]}>
                  {membershipData.emergency.description}
                </p>
                <p className={styles["card-description"]}>
                  {t("membership.ExpirationDate")}:{" "}
                  {membershipData.emergency.expirationDate}
                </p>
              </div>
            </div>
            <span className={styles["action-link"]}>
              {membershipData.emergency.actionText}
            </span>
          </div>
          <div className={styles["divider"]}></div>
          <div className={styles["benefits-section"]}>
            {membershipData.emergency.benefits.map((benefit, index) => (
              <div key={index} className={styles["benefit-item"]}>
                <img
                  src={activeTab === "emergency" ? icon3 : icon4}
                  alt="Benefit Icon"
                  className={styles["benefit-icon"]}
                />
                <div className={styles["benefit-content"]}>
                  <h4 className={styles["benefit-title"]}>
                    {benefit.title}&nbsp;-&nbsp;
                  </h4>
                  <p className={styles["benefit-description"]}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Purchase History 区域 */}
      <div className={styles["purchase-history-container"]}>
        <div className={styles["purchase-history-header"]}>
          <div className={styles["subtitle-section"]}>
            <Title level={3} className={styles["subtitle"]}>
              {t("membership.PurchaseHistory")}
            </Title>
            <span className={styles["subtitle-description"]}>
              ({t("membership.AccessAnywhere")})
            </span>
          </div>
        </div>

        <div className={styles["orders-list-wrapper"]}>
          {/* 表头 */}
          <div className={styles["orders-list-header"]}>
            <div className={styles["header-infos"]}>
              ({t("membership.OrderInformation")})
            </div>
            <div className={styles["header-distance"]}>
              ({t("membership.Distance")})
            </div>
            <div className={styles["header-duration"]}>
              ({t("membership.PurchaseDuration")})
            </div>
            <div className={styles["header-amount"]}>
              ({t("membership.GoodsAmount")})
            </div>
            <div className={styles["header-handle"]}>
              ({t("membership.OrderHandling")})
            </div>
          </div>
          {/* 会员、非会员 购买历史 */}
          {isMember ? (
            purchaseHistoryData[activeTab].map((order: any) => (
              <div key={order.record_id} className={styles["order-block"]}>
                {/* 订单头部 */}
                <div className={styles["order-header"]}>
                  <div className={styles["order-header-left"]}>
                    <span className={styles["order-date"]}>
                      {order.purchase_time}
                    </span>
                    <span className={styles["order-number"]}>
                      {t("membership.OrderNumber")}: {order.record_id}
                    </span>
                    {/* <span className={styles['order-details']}>Order Details {'>'}</span> */}
                  </div>
                </div>

                {/* 订单详情 */}
                <div className={styles["order-body"]}>
                  <div className={styles["order-product-info"]}>
                    <div className={styles["membership-icon"]}>V</div>
                    <div className={styles["product-detail"]}>
                      <div className={styles["membership-type"]}>
                        {t("membership.RideBoardMember")}
                      </div>
                      {/* <div className={styles['expiration-date']}>Expiration Date: {order.expire_time}</div> */}
                    </div>
                  </div>
                  <div className={styles["order-distance-info"]}>
                    <span className={styles["distance"]}>
                      10 {t("membership.Miles")}
                    </span>
                  </div>
                  <div className={styles["order-duration-info"]}>
                    <span className={styles["duration"]}>
                      {order.card_type}
                    </span>
                  </div>
                  <div className={styles["order-price-info"]}>
                    <span className={styles["amount"]}>${order.amount}</span>
                  </div>
                  <div className={styles["order-actions"]}>
                    <button
                      className={styles["renew-btn"]}
                      onClick={() => handleRenew()}
                    >
                      {t("membership.Renew")}
                    </button>
                    <button
                      className={styles["delete-btn"]}
                      onClick={() => {
                        Modal.confirm({
                          title: t("membership.ConfirmDelete"),
                          content: `${t("membership.ConfirmDeleteMark")}?`,
                          okButtonProps: {
                            style: {
                              backgroundColor: "#2aad61", // 确认按钮背景色
                              borderColor: "#2aad61", // 确认按钮边框色
                              color: "#fff", // 确认按钮文字颜色
                            },
                          },
                          cancelButtonProps: {
                            style: {
                              backgroundColor: "#fff", // 取消按钮背景色
                              borderColor: "#2aad61", // 确认按钮边框色
                              color: "#333", // 取消按钮文字颜色
                            },
                          },
                          onOk: async () => {
                            const res = await deleteHistoryRecord(order.record_id)
                            if (res.code === 200) {
                              // 删除成功后重新获取购买记录数据
                              getPurchaseHistory(historyParams);
                              message.success(res.message);
                            } else {
                              message.error(res.message);
                            }
                          },
                        });
                      }}
                    >
                      {t("membership.Delete")}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <OrderEmpty
              img={orderNoneIcon1}
              text={t("membership.NoMemberOrders")}
            ></OrderEmpty>
          )}
          {isMember && purchaseHistoryData[activeTab].length > 0 && historyParams.totalPages > 1 && (
              <div className={styles["pagination-container"]}>
                <div className={styles["pagination-info"]}>
                  {t("searchList.Total")} {historyParams.total} {t('searchList.items')} &nbsp;&nbsp;
                </div>
                <Pagination
                  onChange={historyPaginationChange}
                  current={historyParams.page_num}
                  pageSize={historyParams.page_size}
                  total={historyParams.total}
                  showSizeChanger={false}
                  responsive
                  hideOnSinglePage={historyParams.totalPages <= 1}
                />
                <div className={styles["go-to-page"]}>
                  {t("searchList.goto")}
                  <input
                    className={styles["page-input"]}
                    type="text"
                    value={goToHistoryPage}
                    onChange={(e) => setGoToHistoryPage(e.target.value)}
                    onKeyDown={handleHistoryPageInputKeyDown}
                  />
                  {t("searchList.page")}
                  <Button
                    size="small"
                    style={{ marginLeft: 8 }}
                    onClick={handleHistoryGoToPage}
                  >
                    {t("searchList.GO")}
                  </Button>
                </div>
              </div>
            )}
        </div>
      </div>

      <div className={styles["content-container"]}>
        {/* 拼车内容列表 */}
        {activeTab === "ride" && (
          <div className={styles["content-box"]}>
            <div className={styles["section-header"]}>
              <h2 className={styles["section-title"]}>
                {t("membership.NearbyOrders")}
              </h2>
              {isMember && (
                <span
                  className={`${styles['cursor-pointer']}`}
                  onClick={() => navigate("/carpoolService")}
                >
                  {t("membership.ViewAll")}
                </span>
              )}
            </div>
            <div className="mb-[20px] text-sm text-gray-500">
              {isMember ? t('membership.RideBoardMark') : t('membership.RideBoardNoneMark')}
            </div>
            {/* 拼车列表 */}
            {isMember ? (
              <div className={styles["cards-grid"]}>
                {carList.map((item, idx) => (
                  <div className={styles["order-card"]} key={idx}>
                    <div className={styles["card-top"]}>
                      <div className={styles["status-badge"]}>
                        <span className={styles["percent"]}>95%</span>
                        <span className={styles["status"]}>
                          {t("membership.OnTheWay")}
                        </span>
                      </div>
                      <div className={styles["datetime"]}>
                        <span className={styles["date"]}>
                          {item.departure_date}
                        </span>
                      </div>
                    </div>

                    <div className={styles["addr-box"]}>
                      <ul className={styles["addr-list"]}>
                        <li
                          className={styles["addr-item"]}
                          title={
                            item.starting_point_address +
                            ", " +
                            item.starting_point_city +
                            "," +
                            item.starting_point_state
                          }
                        >
                          {item.starting_point_address +
                            ", " +
                            item.starting_point_city +
                            "," +
                            item.starting_point_state}
                        </li>
                        <li
                          className={styles["addr-item"]}
                          title={
                            item.destination_point_address +
                            ", " +
                            item.destination_point_city +
                            "," +
                            item.destination_point_state
                          }
                        >
                          {item.destination_point_address +
                            ", " +
                            item.destination_point_city +
                            "," +
                            item.destination_point_state}
                        </li>
                        <li
                          className={`${styles["addr-item"]} ${styles["distance"]}`}
                        >
                          <img
                            src={carIcon2}
                            alt=""
                            className={styles["pin"]}
                          />
                          {item.distance} {t("searchList.MilesFromYou")}
                        </li>
                      </ul>

                      <div className={styles["price-box"]}>
                        <div className={styles["price"]}>
                          ${item.budget_price}
                        </div>
                        <div className={styles["estimate"]}>
                          {t("membership.Estimate")}
                        </div>
                      </div>
                    </div>

                    <div className={styles["card-bottom"]}>
                      <div>
                        <div className={styles["meta"]}>
                          <span className={styles["meta-label"]}>
                            {t("membership.Seats")}:
                          </span>
                          <span className={styles["meta-value"]}>
                            {item.seats_needed} {t("membership.People")}
                          </span>
                        </div>
                        <div className={styles["meta"]}>
                          <span className={styles["meta-label"]}>
                            {t("membership.Luggage")}:
                          </span>
                          <span className={styles["meta-value"]}>
                            {item.has_luggage
                              ? t("membership.HasLuggage")
                              : t("membership.NoLuggage")}
                          </span>
                        </div>
                      </div>

                      <Button
                        className={styles["details-btn"]}
                        onClick={() =>
                          navigate(
                            `/CarpoolServiceDetail/${item.carpool_order_id}`
                          )
                        }
                      >
                        {t("membership.Bidding")}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <OrderEmpty
                img={orderNoneIcon2}
                text={t("membership.NoOrdersAvailable")}
              ></OrderEmpty>
            )}
            {isMember && carList.length > 0 && (
              <div className={styles["pagination-container"]}>
                <div className={styles["pagination-info"]}>
                  {t("searchList.Total")} {params.total}{" "}
                  {t("searchList.Products")}
                </div>
                <Pagination
                  onChange={paginationChange}
                  current={params.page_num}
                  pageSize={params.page_size}
                  total={params.total}
                  showSizeChanger={false}
                  responsive
                  hideOnSinglePage={params.totalPages <= 1}
                />
                <div className={styles["go-to-page"]}>
                  {t("searchList.goto")}
                  <input
                    className={styles["page-input"]}
                    type="text"
                    value={goToPage}
                    onChange={(e) => setGoToPage(e.target.value)}
                    onKeyDown={handlePageInputKeyDown}
                  />
                  {t("searchList.page")}
                  <Button
                    size="small"
                    style={{ marginLeft: 8 }}
                    onClick={handleGoToPage}
                  >
                    {t("searchList.GO")}
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
        {/* 紧急服务内容列表 */}
        {/* {activeTab === 'emergency' && ( */}

        <div className={styles["content-box"]}>
          <NearbyOrders
            serviceCategories={cascaderOptions}
            refresh={refreshNearbyOrders}
            isShowExpandRange={true}
          />
        </div>
        {/* )} */}
      </div>

      <Membership
        open={membershipModalOpen}
        onCancel={handleMembershipCancel}
        onConfirm={handleMembershipConfirm}
        membershipType={1}
      />

      {/* 会员支付成功弹窗 */}
      <Modal
        open={showPaySuccess}
        onCancel={closePaySuccess}
        footer={null}
        width={800}
        centered
        className={styles["pay-success-modal"]}
      >
        <div className={styles["pay-success-content"]}>
          <div className={styles["success-icon"]}>
            <CheckOutlined />
          </div>
          <div className={styles["success-title"]}>
            {t("membership.PaySuccess")}
          </div>
        </div>
      </Modal>
      {/* 会员支付成功弹窗 */}
    </div>
  );
};

export default MembershipService;
